// extracted by mini-css-extract-plugin
export default {"root":"qCORM","priority-primary":"_9LV7k","priorityPrimary":"_9LV7k","disabled":"ITA-e","priority-secondary":"_1JqWZ","prioritySecondary":"_1JqWZ"};